import UI from "../../components/ExcerciseTypes/Design/UserInterface";

const json = {
  1: {
    // Exercise num
    unit: "Unit 9",
    id: "SB3-U9-P62-E1",
    audio: "img/FriendsPlus/Page62/Audio/audio-e1-p62.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        // Column1
        { url: "img/FriendsPlus/Page62/E1/1.jpg" },
        {
          url: "img/FriendsPlus/Page62/E1/2.jpg",
          audioUrl: "img/FriendsPlus/Page62/Audio/tieude-e1-p62.mp3",
        },
        { url: "img/FriendsPlus/Page62/E1/3.jpg" },
      ],
      [
        // Column2
        { url: "img/FriendsPlus/Page62/E1/4.jpg" },
        {
          url: "img/FriendsPlus/Page62/E1/5.jpg",
          audioUrl: "img/FriendsPlus/Page62/Audio/hinh1-e1-p62.mp3",
        },
        { url: "img/FriendsPlus/Page62/E1/6.jpg",
        audioUrl: "img/FriendsPlus/Page62/Audio/hinh2-e1-p62.mp3", },
        {
          url: "img/FriendsPlus/Page62/E1/7.jpg",
          audioUrl: "img/FriendsPlus/Page62/Audio/hinh3-e1-p62.mp3",
        },
        { url: "img/FriendsPlus/Page62/E1/8.jpg",
        audioUrl: "img/FriendsPlus/Page62/Audio/hinh4-e1-p62.mp3", },
        {
          url: "img/FriendsPlus/Page62/E1/9.jpg"
        },
      ],
    ],
  },
  2: {
    // Exercise num
    unit: "Unit 9",
    id: "SB3-U9-P62-E2",
    audio: "img/FriendsPlus/Page62/Audio/audio-e2-p62.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        // Column1
        { url: "img/FriendsPlus/Page62/E2/1.jpg" },
        {
          url: "img/FriendsPlus/Page62/E2/2.jpg",
          audioUrl: "img/FriendsPlus/Page62/Audio/tieude-e2-p62.mp3",
        },
        { url: "img/FriendsPlus/Page62/E2/3.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page62/E2/4.jpg" }],
    ],
  },
  3: {
    // Exercise num
    unit: "Unit 9",
    id: "SB3-U9-P62-E3",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [{ url: "img/FriendsPlus/Page62/E3/1.jpg" }],
    ],
  },
};

export default json;
